import React from "react";
import Checkbox from "../../../common/checkbox/Checkbox";
import DialogBoxComponent from "../../../common/dialogs/DialogBoxComponent";
import FullScreenLoader from "../../../common/loaders/FullScreenLoader";
import FullScreenOverlay from "../../../common/overlay/FullScreenOverlay";
import TermsAndPrivacyPanel from "../../../common/termsandConditions/TermsAndPrivacyPanel";

export default function StorePopups({
    isOpeningHoursLoading,
    isLoading,
    isLoadingStoreData,
    showTAC,
    setShowTAC,
    showCorrectCompanyPopup,
    showIsStorePosSavedPopup,
    correctCompanyChecked,
    setCorrectCompanyChecked,
    setShowCorrectCompanyPopup,
    showDialogBox = false,
    setShowDialogBox,
    storeID,
    onSaveClicked,
    createStoreLoading,
    editStoreLoading,
    setShowIsStorePosSavedPopup
}) {
    return (
        <div>
            <FullScreenOverlay show={isOpeningHoursLoading}>
                <DialogBoxComponent
                    headingColor="rgba(0, 174, 239, 1)"
                    loading={true}
                    showCancel={false}
                    showConfirm={false}
                    loadingHeading="FETCHING STORE HOURS FROM GOOGLE MAPS..."
                />
            </FullScreenOverlay>

            <FullScreenLoader isLoading={isLoading || isLoadingStoreData} />

            <FullScreenOverlay show={showTAC}>
                <TermsAndPrivacyPanel type="terms" onCloseClicked={() => setShowTAC(false)} />
            </FullScreenOverlay>

            <FullScreenOverlay show={showCorrectCompanyPopup && !showIsStorePosSavedPopup}>
                <DialogBoxComponent
                    headingColor="var(--text-icons-blue-500)"
                    title="Correct company?"
                    useAlternativeLayout={
                        <div style={{ margin: "0 -5px" }}>
                            <span>
                                This store will operate under{" "}
                                {localStorage.getItem("currentCompanyName") || "current company"}. If you have stores
                                that operate under a different company you need to add a new company to this account or
                                create a new BOstageR account.
                            </span>

                            <div className="flex flex-row items-center justify-center mt-16px mb-32px">
                                <Checkbox
                                    style={{ top: "-1px", position: "relative" }}
                                    isChecked={correctCompanyChecked}
                                    onCheckboxClick={() => {
                                        setCorrectCompanyChecked(!correctCompanyChecked);
                                    }}
                                />
                                <span className="ml-8px">Don't show again</span>
                            </div>
                        </div>
                    }
                    onClickYes={() => {
                        if (correctCompanyChecked) localStorage.setItem("disableShowCorrectCompanyPopup", "true");
                        setShowCorrectCompanyPopup(false);
                    }}
                    showCancel={false}
                    confirmText="CONFIRM"
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showDialogBox}>
                <DialogBoxComponent
                    headingColor="var(--text-icons-blue-500)"
                    title="Ready to save?"
                    message={
                        !!storeID
                            ? "You can still change it later. No worries:)"
                            : "Store status will become ‘Active’ and will be ready to accept invitations from brands to become their fulfillment centers."
                    }
                    onClickYes={() => {
                        onSaveClicked();
                        setShowDialogBox(false);
                    }}
                    onClickNo={() => {
                        setShowDialogBox(false);
                    }}
                    cancelText="No"
                    confirmText="Yes"
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={createStoreLoading || editStoreLoading}>
                <DialogBoxComponent
                    headingColor="var(--text-icons-green-500)"
                    heading="SAVING..."
                    showCancel={false}
                    showConfirm={false}
                    loading={createStoreLoading || editStoreLoading}
                />
            </FullScreenOverlay>

            <FullScreenOverlay show={showIsStorePosSavedPopup}>
                <DialogBoxComponent
                    title="POS data saved."
                    message="Let's create your first store now!"
                    onClickYes={() => setShowIsStorePosSavedPopup(false)}
                    heading={"SUCCESS..."}
                    headingColor="var(--text-icons-green-500)"
                    confirmText="CONTINUE"
                    showCancel={false}
                    confirmState="secondary"
                    buttonWidth="150px"
                />
            </FullScreenOverlay>
        </div>
    );
}
